/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Calculator as CalculatorModel } from 'models';
import { Bind, Debounce } from 'lodash-decorators';
import CalculatorMainView from 'kentico-blocks/Calculator/CalculatorMainView';
import CalculatorDetailsView from 'kentico-blocks/Calculator/CalculatorDetailsView';
import Carousel from 'blocks/Carousel/Carousel';
import MobileOptimisationModal
  from 'kentico-blocks/Calculator/CalculatorMainView/MobileOptimisationModal';
import { observable } from 'mobx';
import root from 'window-or-global';

@inject('windowStore', 'calculatorStore')
@observer
export default class Calculator extends Component {
  static carouselSettings = {
    swipe: false,
    slidesToShow: 1,
    dots: false,
    infinite: false,
    arrows: false,
    slidesToScroll: 1,
  };

  @observable inViewport = false;

  @observable isMainView = true;

  componentDidMount() {
    const {
      calculatorStore,
      data,
    } = this.props;
    calculatorStore.setCalcData(data);
    root.addEventListener('scroll', this.checkIfInViewport);
    root.addEventListener('resize', this.checkIfInViewport);
  }

  componentWillUnmount() {
    root.removeEventListener('scroll', this.checkIfInViewport);
    root.removeEventListener('resize', this.checkIfInViewport);
  }

  @Bind
  onModalClick() {
    if (this.sideInfoRef) {
      this.sideInfoRef.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  @Debounce(200)
  @Bind
  checkIfInViewport() {
    if (this.calculatorDetailsRef && this.sideInfoRef) {
      const containerRect = this.calculatorDetailsRef.getBoundingClientRect();
      this.inViewport = containerRect.y < root.innerHeight / 3
        && containerRect.y > -(containerRect.height * 0.47) + root.innerHeight;
    }
  }

  @Bind
  slickNext() {
    const { windowStore } = this.props;
    if (this.sliderRef) {
      this.sliderRef.slickNext();
      this.isMainView = false;
      setTimeout(() => {
        if (this.calculatorDetailsRef && !windowStore.isOnDesktop) {
          this.calculatorDetailsRef.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    }
  }

  @Bind
  slickPrev() {
    if (this.sliderRef) {
      this.sliderRef.slickPrev();
      this.isMainView = true;
    }
  }

  render() {
    const {
      windowStore,
      calculatorStore,
      data,
    } = this.props;
    return (
      <React.Fragment>
        {!windowStore.isOnDesktop && (
          <MobileOptimisationModal
            value={calculatorStore.totalOptimisationPerMonth}
            currency={data.currency}
            period={data.sideInfoOptimisationFrequency}
            description={data.valueOfOptimisationText}
            linkText={data.linkToMoreDataText}
            show={this.inViewport && this.isMainView}
            onClick={this.onModalClick}
          />
        )}
        <Carousel
          innerRef={(ref) => { this.sliderRef = ref; }}
          cursorDefault
          settings={Calculator.carouselSettings}
          selectable
          noMarginBottom
        >
          <CalculatorMainView
            data={data}
            sideInfoRef={(ref) => { this.sideInfoRef = ref; }}
            onClickNext={this.slickNext}
          />
          <CalculatorDetailsView
            data={data}
            onClickPrev={this.slickPrev}
            innerRef={(ref) => { this.calculatorDetailsRef = ref; }}
          />
        </Carousel>
      </React.Fragment>
    );
  }
}
Calculator.propTypes = {
  data: PropTypes.instanceOf(CalculatorModel).isRequired,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/index.jsx